import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import Auth from '../../commons/Auth/Auth'

const ConfirmRegisterPhoneContainer = () => {
  const dispatch = useDispatch()
  const handleSubmit = (data) =>
    dispatch(reducks.resources.users.actions.confirmUserPhone(data))

  const handleResent = () =>
    dispatch(reducks.resources.users.actions.confirmUserPhoneResent())

  const error = useSelector((state) => state.usersReducer.content.error)

  useEffect(() => {
    const requirements = ['email', 'password']

    dispatch(
      reducks.resources.users.actions.registerUserRequirements(
        requirements,
        routes.registerCNPJ.path
      )
    )
  }, [])

  return (
    <Auth
      handleSubmit={handleSubmit}
      handleResent={handleResent}
      error={error}
    />
  )
}

export default ConfirmRegisterPhoneContainer
